import { useState } from "react";
import { Award, Check } from "lucide-react";
import { toast } from "sonner";
import { giveAward } from "@/lib/rewards";
import { errorText } from "@/lib/family";
import { playChime } from "@/lib/chime";

export const ParentGoldenShortcut = ({ profile, reason, onGiven }) => {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [given, setGiven] = useState(false);

  const give = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await giveAward(pin, { profile_id: profile.id, reason, note: note.trim() || null });
      playChime(true); setGiven(true); onGiven?.();
      toast.success(`Golden acorn given to ${profile.name}!`);
    } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };

  if (given) return <p className="pp-reward gold mt-6" data-testid="parent-golden-given"><Check className="inline h-4 w-4" /> Parent golden acorn given. So proud!</p>;
  if (!profile) return <p className="pp-feedback small mt-6" data-testid="parent-golden-no-profile">Parents: pick your child's name on the home page to give a golden acorn from here.</p>;
  return (
    <section className="pp-card pp-parent-golden mt-6" data-testid="parent-golden-shortcut">
      <p className="pp-label">For parents</p>
      {!open ? (
        <button className="pp-primary" onClick={() => setOpen(true)} data-testid="parent-golden-open">
          <Award className="h-5 w-5" /> Give {profile.name} a golden acorn
        </button>
      ) : (
        <form onSubmit={give} className="grid gap-2" data-testid="parent-golden-form">
          <p className="opacity-80">Reason: <b>{reason}</b></p>
          <input className="pp-input" type="password" inputMode="numeric" maxLength={4} placeholder="Parent PIN" value={pin}
            onChange={(e) => setPin(e.target.value)} data-testid="parent-golden-pin" autoFocus />
          <input className="pp-input" maxLength={200} placeholder="Add a proud note (optional)" value={note}
            onChange={(e) => setNote(e.target.value)} data-testid="parent-golden-note" />
          <button className="pp-primary mt-2" disabled={busy || pin.length < 4} data-testid="parent-golden-give">
            <Award className="h-5 w-5" /> Give golden acorn
          </button>
        </form>
      )}
    </section>
  );
};
